/**
 * Helper per anagrafiche hotel flaggate come disattivate (hotel_deleted).
 * In UI si mostra "disattivata"; il campo API resta hotel_deleted.
 */

export function isHotelDeleted(item) {
    if (!item) {
        return false;
    }

    const value = item.hotel_deleted !== undefined ? item.hotel_deleted : item.hotelDeleted;

    return value === 1 || value === true || value === '1';
}

export function formatHotelOptionLabel(item) {
    const base = `${item.nome_hotel} - ${item.nome_posizione} (${item.idHotel})`;

    if (isHotelDeleted(item)) {
        return `${base} [disattivata]`;
    }

    return base;
}

export function mapHotelToSelectOption(item) {
    const hotelDeleted = isHotelDeleted(item);

    return {
        value: item.idHotel,
        label: formatHotelOptionLabel(item),
        comuneId: item.idComune,
        hotelDeleted,
        className: hotelDeleted ? 'text-danger' : undefined,
        item,
    };
}

export function sortHotelsActiveFirst(options) {
    return [...options].sort(
        (a, b) => Number(!!a.hotelDeleted) - Number(!!b.hotelDeleted)
    );
}

export function hotelDeletedTextStyle(itemOrFlag) {
    const deleted =
        typeof itemOrFlag === 'boolean'
            ? itemOrFlag
            : isHotelDeleted(itemOrFlag);

    return deleted ? { color: '#dc3545' } : undefined;
}
